import{css,styled}from"styled-components";import IconButton from"../../button/icon/index.js";import{breakpoint,color}from"../../tokens/index.js";import{sidebarAppearance}from"../sidebar.props.js";export const SubNavigation=/*#__PURE__*/styled.aside.withConfig({componentId:"sc-on49np-0"})`position:fixed;top:0;left:0;z-index:1001;width:100%;height:100dvh;display:flex;flex-direction:column;padding:0 16px 24px;background-color:${color.neutral.offWhite};@media screen and (min-width:${breakpoint.sm}px){z-index:999;width:280px;height:100vh;}${({$appearance})=>sidebarAppearance.match($appearance).with(sidebarAppearance.light,()=>css`
                    color: ${color.neutral.body};
                    background-color: ${color.neutral.offWhite};

                    ${Header} {
                        color: ${color.neutral.section};
                    }

                    @media screen and (min-width: ${breakpoint.sm}px) {
                        border-right: 1px solid ${color.neutral.border};
                    }
                `).with(sidebarAppearance.dark,()=>css`
                    color: ${color.neutral.bg};
                    background-color: ${color.brand.blueActive};

                    ${Header} {
                        color: ${color.neutral.offWhite};

                        .ovpn-icon-button {
                            color: ${color.neutral.white} !important;
                            border-color: transparent !important;

                            &:hover,
                            &:active {
                                background-color: ${color.brand.blueHover} !important;
                            }
                        }
                    }

                    & .ovpn-divider {
                        & > hr {
                            background-color: ${color.neutral.subtitle};
                        }
                    }

                    .ovpn-listbox-option,
                    .ovpn-sidebar-navigation-menu__option {
                        color: ${color.neutral.bg} !important;
                        background-color: ${color.brand.blueActive} !important;

                        &:hover,
                        &[aria-selected='true'] {
                            background-color: ${color.brand.blueHover} !important;
                        }
                    }

                    @media screen and (min-width: ${breakpoint.sm}px) {
                        border-right: 1px solid ${color.neutral.borderHover};
                    }
                `).exhaustive()}`;export const Header=/*#__PURE__*/styled.header.withConfig({componentId:"sc-on49np-1"})`position:relative;display:flex;align-items:center;justify-content:space-between;padding:24px 0;`;export const CloseButton=/*#__PURE__*/styled(IconButton).withConfig({componentId:"sc-on49np-2"})`color:${color.neutral.subtitle};background-color:transparent;`;export const Body=/*#__PURE__*/styled.div.withConfig({componentId:"sc-on49np-3"})`display:flex;flex-direction:column;flex-grow:1;gap:32px;width:100%;.ovpn-listbox-option{&:not([aria-selected]){background-color:transparent;}}`;
//# sourceMappingURL=sub-navigation.styles.js.map